/* Carrousel des avis clients.
   Le defilement natif reste le mecanisme : les fleches ne font que le piloter.
   On garde ainsi le clavier, le tactile et la molette, et sans JavaScript la
   section reste utilisable, simplement sans boutons. */
class PkAvisCarrousel extends HTMLElement {
  connectedCallback() {
    this.piste = this.querySelector('[data-pk-piste]');
    this.prec = this.querySelector('[data-pk-prec]');
    this.suiv = this.querySelector('[data-pk-suiv]');
    if (!this.piste || !this.prec || !this.suiv) return;

    this.majEtat = this.majEtat.bind(this);

    this.prec.addEventListener('click', () => this.glisser(-1));
    this.suiv.addEventListener('click', () => this.glisser(1));
    this.piste.addEventListener('scroll', this.majEtat, { passive: true });
    window.addEventListener('resize', this.majEtat);

    this.majEtat();
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.majEtat);
  }

  /** Largeur d'un pas : une carte plus son ecart. */
  pas() {
    const carte = this.piste.querySelector('.pk-avis__carte');
    if (!carte) return this.piste.clientWidth;
    const ecart = parseFloat(getComputedStyle(this.piste).columnGap || '0') || 0;
    return carte.getBoundingClientRect().width + ecart;
  }

  glisser(sens) {
    this.piste.scrollBy({ left: sens * this.pas(), behavior: 'smooth' });
  }

  majEtat() {
    const p = this.piste;
    // Marge de 12 px, et ce n'est pas arbitraire : la piste porte un filet de
    // remplissage et l'accrochage (`scroll-snap`) laisse la position de depart a
    // quelques pixels de zero. Mesure : 3 px au chargement, ce qu'une tolerance
    // de 2 px prenait pour « deja defile », laissant la fleche gauche active
    // alors qu'il n'y avait rien avant. 12 px reste tres inferieur au pas (316 px).
    const MARGE = 12;
    const max = p.scrollWidth - p.clientWidth;
    const debut = p.scrollLeft <= MARGE;
    const fin = p.scrollLeft >= max - MARGE;
    const rien = max <= MARGE; // tout tient a l'ecran : aucune fleche n'a de sens

    this.prec.hidden = rien || debut;
    this.suiv.hidden = rien || fin;
  }
}

if (!customElements.get('pk-avis-carrousel')) {
  customElements.define('pk-avis-carrousel', PkAvisCarrousel);
}
